import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../../assets/BrandLogo.svg';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Company Info */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img
                src={BrandLogo}
                alt="D-ESPIAL Logo"
                className="h-10 w-auto"
              />
              <div>
                <div className="text-white font-bold text-lg">D-ESPIAL</div>
                <div className="text-sm text-gray-400">Threat Management System</div>
              </div>
            </Link>
            <p className="text-sm text-gray-400 max-w-md">
              Advanced security intelligence platform providing real-time threat
              analysis, incident reporting, and comprehensive security assessments
              across global regions.
            </p>
          </div>

          {/* About Links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              About
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about/overview"
                  className="text-sm hover:text-white transition-colors"
                >
                  Overview
                </Link>
              </li>
              <li>
                <Link
                  to="/about/services"
                  className="text-sm hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Platform Links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Platform
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/dashboard"
                  className="text-sm hover:text-white transition-colors"
                >
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/reports"
                  className="text-sm hover:text-white transition-colors"
                >
                  Reports
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © 2025 D-ESPIAL Threat Management System. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="https://dtms-espial.app"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-white transition-colors"
              >
                Website
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
